// import { getLineColor } from './colors';
import edBs11Info from '../../../data/bs11-info.json';
import edBs10Info from '../../../data/bs10-info.json';
import { ElectoralDistrictInfo } from '../../../store/layerStore';

enum BoundarySet {
    Bs10 = 10,
    Bs11 = 11,
}

export const bs10EdBounds: any = (abbr: string) => {
    return edBounds(abbr,BoundarySet.Bs10);
}

export const bs10RegionBounds: any = (region: string) => {
    return regionBounds(region, BoundarySet.Bs10);
}

export const bs10EdInfo = (abbr: string) => {
    return edInfo(abbr, BoundarySet.Bs10);
}

export const bs11EdBounds: any = (abbr: string) => {
    return edBounds(abbr,BoundarySet.Bs11);
}
export const bs11RegionBounds: any = (region: string) => {
    return regionBounds(region, BoundarySet.Bs11);
}

export const bs11EdInfo = (abbr: string) => {
    return edInfo(abbr, BoundarySet.Bs11);
}


const edBounds = (abbr: string, bs: BoundarySet) => {
  const info = (bs === BoundarySet.Bs11 ? edBs11Info : edBs10Info).filter(o => o.edAbbr === abbr)[0];
  const bnd = new google.maps.LatLngBounds({lat: info.minLat, lng: info.minLng}, {lat: info.maxLat, lng: info.maxLng});
  return bnd;
}

const regionBounds = (region: string, bs: BoundarySet) => {
  const regions = (bs === BoundarySet.Bs11 ? edBs11Info : edBs10Info).filter(o => o.region.toLowerCase() === region.toLowerCase());
  const minLat = Math.min(...regions.map(r => r.minLat));
  const minLng = Math.min(...regions.map(r => r.minLng));
  const maxLat = Math.max(...regions.map(r => r.maxLat));
  const maxLng = Math.max(...regions.map(r => r.maxLng));
  //const bnd = new google.maps.LatLngBounds({lat: minLat, lng: minLng}, {lat: maxLat, lng: maxLng});
  const bnd = {east: maxLng, west: minLng, north: maxLat, south: minLat};
  // var tmp;
  // for (var i = regions.length-1; i >= 1; i--) {
  //   tmp = regions[i]
  // }
  return bnd;
}

const edInfo = (abbr: string, bs: BoundarySet) => {
  let info = (bs === BoundarySet.Bs11 ? edBs11Info : edBs10Info).filter(o => o.edAbbr.toLowerCase() === abbr.toLowerCase()).map(o => ({
    edName: o.edName,
    edAbbr: o.edAbbr,
    area: o.area,
    groupName: o.groupName,
    minLng: o.minLng,
    minLat: o.minLat,
    maxLng: o.maxLng,
    maxLat: o.maxLat,
    // bounds_: new google.maps.LatLngBounds({lat: o.minLat, lng: o.minLng}, {lat: o.maxLat, lng: o.maxLng}),
    bounds: {west: o.minLng, east: o.maxLng, south: o.minLat, north: o.maxLat},
    centroidLng: o.centroidLng,
    centroidLat: o.centroidLat,
  }));
  return info[0];
}

/**
 * Convert latLng coords to xy DOM coords
 * @param mapInstance
 * @param latLng
 */
const fromLatLngToPoint = (
  latLng: google.maps.LatLng | google.maps.LatLngLiteral,
  map: google.maps.Map
): google.maps.Point => {
  const projection: google.maps.Projection = map.getProjection()!;
  const bounds = map.getBounds()!;

  const topRight = projection.fromLatLngToPoint(bounds.getNorthEast())!;
  const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest())!;

  const scale = Math.pow(2, map.getZoom()!);
  const worldPoint = projection.fromLatLngToPoint(latLng)!;

  return new google.maps.Point(
    (worldPoint.x - bottomLeft.x) * scale,
    (worldPoint.y - topRight.y) * scale
  );
};

export const showPolygonTooltip = ({
  map,
  latLng,
  lineName,
}: {
  map: google.maps.Map;
  latLng: google.maps.LatLng;
  lineName: string;
}) => {
  const { x, y } = fromLatLngToPoint(latLng, map);
  const tooltip = document.getElementById('lineTooltip');
  if (tooltip) {
  tooltip.innerHTML = `
  Line ${lineName}
  `;
  tooltip.setAttribute(
    'style',
    `position: fixed;
     display: flex;
     font-family: system-ui;
     padding: 8px;
     border-radius: 8px;
     background: #EE352E;
     color: white;
     top: ${y}px;
     left: ${x}px;`
  );
  //background: ${getLineColor(lineName)};
  }
};

export const hidePolygonTooltip = () => {
  //document?.getElementById('lineTooltip')?.setAttribute('style', 'display: none;');
};